import { PrintOptionsVisibility } from '@modeso/aumico-lib-annualreport-fe';
import { AnnualReportStep, ReportType } from '@modeso/types__aumico-lib-annualreport-be';
import { IDisplayOptionsVisibility } from '../../../../../../aumico-lib-annualreport-fe/src/lib/interfaces/display-options-visibility.interface';
import { SignatureOptionsSwissVisibility } from '../../../../../../aumico-lib-annualreport-fe/src/lib/types/signature-options.swiss-visibility.type';

export class PrintPreviewHelper {
    static adjustPrintOptionsVisibilityAccordingToNavigation(
        navigations: AnnualReportStep[],
    ): Partial<PrintOptionsVisibility> {
        let printOptionsVisibility: Partial<PrintOptionsVisibility> = {
            displayOptions: {} as IDisplayOptionsVisibility,
            signatureOptions: {} as SignatureOptionsSwissVisibility,
        };

        navigations.forEach((navigation) => {
            if (navigation === AnnualReportStep.BALANCE_ACCOUNT_PROOF) {
                printOptionsVisibility.displayOptions.hasAccountProofForBalanceToggle = true;
            }
            if (navigation === AnnualReportStep.INCOME_ACCOUNT_PROOF) {
                printOptionsVisibility.displayOptions.hasAccountProofForIncomeToggle = true;
            }
            if (navigation === AnnualReportStep.EMS) {
                printOptionsVisibility.displayOptions.hasEmsToggle = true;
            }
            if (navigation === AnnualReportStep.FAS) {
                printOptionsVisibility.displayOptions.hasFasToggle = true;
            }
            if (navigation === AnnualReportStep.NOTES) {
                printOptionsVisibility.displayOptions.hasNotesToggle = true;
            }
            if (navigation === AnnualReportStep.CFS) {
                printOptionsVisibility.displayOptions.hasCfsToggle = true;
            }
            if (navigation === AnnualReportStep.AOP) {
                printOptionsVisibility.displayOptions.hasAopToggle = true;
                printOptionsVisibility.signatureOptions.placeSignatureAfterAop = true;
            }
            if (navigation === AnnualReportStep.FINANCIAL_CLOSING_PROCESS) {
                printOptionsVisibility.displayOptions.hasFcpToggle = true;
            }
            if (navigation === AnnualReportStep.CR) {
                printOptionsVisibility.displayOptions.hasComplementaryReportsToggle = true;
            }
        });
        return printOptionsVisibility;
    }

    static getPredefinedLocalizationKeyForReportMainTitle(reportType: string | undefined): string {
        switch (reportType) {
            case ReportType.ANNUAL:
                return 'aumico_reports_annualreport_cover_annual_label_title_1st_prefix';
            case ReportType.QUARTERLY:
                return 'aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix';
            case ReportType.MONTHLY:
                return 'aumico_reports_annualreport_cover_monthly_label_title_1st_prefix';
            case ReportType.CUSTOM:
                return 'aumico_reports_annualreport_cover_custom_label_title_1st_prefix';
            default:
                return 'aumico_reports_annualreport_cover_annual_label_title_1st_prefix';
        }
    }

}
